import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Checkbox } from "semantic-ui-react";
import LoadingSpinner from "../LoadingSpinner";
import Grid from "../Grid";
import {
  getDropdownData,
  getFieldValuesByTableAndId,
  getOtherRefSearchDropdown,
  getTextByValueAndKey,
} from "../../api/keyvalue";
import { accidentValidation } from "../validations/vehicleCreation";
import ButtonRenderer from "../renderer/ButtonRenderer";
import Input from "../input/Input";
import Dropdown from "../input/Dropdown";
import SearchDropdown from "../input/SearchDropdown";
import Button from "../input/Button";
import { ResizableScrollingTextRenderer } from "../renderer/StyleRenderer";
import { AUTH_TYPES, FORMS, MODULES } from "../../const";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { isNumber } from "../../helper";
import DeleteButtonRenderer from "../renderer/DeleteButtonRenderer";

const FORM = FORMS.VEHICLE.BREAKDOWN.form;

const VehicleAccidents = forwardRef(
  ({ dropdown, isLoading, editMode, currentValues, reference }, ref) => {
    const [currentErrors, setCurrentErrors] = useState({});
    const [isAddLoading, setIsAddLoading] = useState(false);
    const [currentAccident, setCurrentAccident] = useState({}); //newly added
    const [buttonClicked, setButtonClicked] = useState(false); //newly added
    const [deletedList, setDeletedList] = useState([]); //newly added
    const [searchFieldReset, setSearchFieldReset] = useState(false);

    const [categorySelected, setCategorySelected] = useState(false);
    const [typeOpt, setTypeOpt] = useState([]);
    const [typeOptLoading, setTypeOptLoading] = useState(false);

    const [accidentsData, setAccidentsData] = useState([]); //newly added
    const [accidentCount, setAccidentCount] = useState(2); //newly added

    const [accidents, setAccidents] = useState({
      vacCode: "",
      vacReference: "",
      vacCategory: "",
      vacCategoryValue: "",
      vacType: "",
      vacJobValue: "",
      vacTypeValue: "",
      vacDriver: "",
      vacDriverValue: "",
      vacHelper: "",
      vacHelperValue: "",
      vacDate: "",
      vacFromDate: "",
      vacToDate: "",
      vacJob: "",
      vacDescription: "",
      vacAccidentStatus: "",
      vacStatus: 2,
      vacActive: 1,
      vacActiveValue: "",
      vacBlock: false,
    });

    useEffect(() => {
      (async () => {
        if (editMode) {
          let currentAccidents = [];
          let id = 2;
          for (let currentValue of currentValues) {
            currentAccidents.push({
              ...currentValue,
              vacDriver: currentValue.vacDriverId,
              vacHelper: currentValue.vacHelperId,
              vacVehicle: currentValue.vacVehicleId,
              vacDate: formatDateForInput(currentValue.vacDate),
              vacFromDate: formatDateForInput(currentValue.vacFromDate),
              vacToDate: formatDateForInput(currentValue.vacToDate),
              vacJob: currentValue.vacJobId,
              vacJobValue: currentValue.vacJobCode,
              id: id,
            });
            id++;
          }
          setAccidentCount(id);
          setAccidentsData(currentAccidents);
        }
      })();
    }, [editMode, currentValues]);

    useEffect(() => {
      if (buttonClicked) {
        setAccidents({
          vacCode: "",
          vacReference: "",
          vacCategory: "",
          vacCategoryValue: "",
          vacType: "",
          vacTypeValue: "",
          vacDriver: "",
          vacDriverValue: "",
          vacHelper: "",
          vacHelperValue: "",
          vacDate: "",
          vacFromDate: "",
          vacToDate: "",
          vacJob: "",
          vacAccidentStatus: "",
          vacStatus: 2, //doen't exist in front end
          vacActive: 1,
          vacActiveValue: "",
          vacBlock: false,
        });
        setCurrentErrors({});
        setSearchFieldReset(true);
        setButtonClicked(false);
        setCurrentAccident({});
      }
    }, [buttonClicked]);
    console.log(accidents);

    useEffect(() => {
      if (Object.keys(currentAccident).length > 0) {
        setAccidents({
          ...currentAccident,
        });
      }
    }, [editMode, currentAccident]);

    useImperativeHandle(ref, () => ({
      resetGrid: () => {
        setAccidentsData([]);
      },
      // getData: () => (accidentsData.length > 0 ? accidentsData[0] : accidents),
      getData: () => {
        if (editMode) {
          const updateState = {
            modified: [],
            unmodified: [],
            created: [],
            deleted: deletedList,
          };

          accidentsData.forEach((accident) => {
            if (accident.vacId && accident.vacId !== null) {
              if (accident.modified) {
                updateState.modified.push(accident);
              } else {
                updateState.unmodified.push(accident);
              }
            } else {
              updateState.created.push(accident);
            }
          });

          return updateState;
        } else {
          return accidentsData;
        }
      },
    }));

    useEffect(() => {
      (async () => {
        if (accidents.vacCategory) {
          setTypeOptLoading(true);
          const vacTypeData = await getDropdownData(
            "vac_type",
            accidents.vacCategory.toString(),
          );
          console.log("vacTypeData", vacTypeData);
          setTypeOpt(vacTypeData);
          setTypeOptLoading(false);
        }
      })();
    }, [categorySelected, accidents.vacCategory]);

    const handleCategoryChange = (e, data) => {
      const selectedCategory = data.value;

      setAccidents((prev) => ({
        ...prev,
        vacCategory: selectedCategory,
      }));
      setCategorySelected(true);
    };

    const formatDateForInput = (dateString) => {
      if (!dateString) return "";

      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    };

    const onAddClick = async () => {
      setIsAddLoading(true);
 
      const accidentsErrors = accidentValidation(accidents);
      const isEditing = Boolean(accidents.vacId);
      console.log("accidents", accidents);
      const isDuplicate = accidentsData.some((existingAccident) => {
        console.log("existingAccidents", existingAccident);
        return (
          existingAccident.vacDriver === accidents.vacDriver &&
          existingAccident.vacCategory === accidents.vacCategory &&
          existingAccident.vacType === accidents.vacType &&
          existingAccident.vacFromDate === accidents.vacFromDate &&
          existingAccident.vacToDate === accidents.vacToDate &&
          existingAccident.vacId !== accidents.vacId &&
          existingAccident.id !== accidents.id
        );
      });
 
      if (isDuplicate) {
        toast.error("Duplicate record detected. Please modify the values.", {
          autoClose: 5000,
          containerId: "Main",
        });
        setCurrentErrors({
          ...accidentsErrors,
          duplicateError:
            "A record with the same driver, category, type, from date, and to date already exists.",
        });
        setIsAddLoading(false);
        return;
      }
 
      const isOverlap = accidentsData.some((existingAccident) => {
        return (
          ((accidents.vacFromDate >= existingAccident.vacFromDate &&
            accidents.vacFromDate <= existingAccident.vacToDate) ||
            (accidents.vacToDate >= existingAccident.vacFromDate &&
              accidents.vacToDate <= existingAccident.vacToDate) ||
            (accidents.vacFromDate <= existingAccident.vacFromDate &&
              accidents.vacToDate >= existingAccident.vacToDate)) &&
          (existingAccident.vacId !== accidents.vacId ||
            existingAccident.id !== accidents.id)
        );
      });
 
      if (isOverlap) {
        toast.error(
          "Date range overlaps with an existing record. Please adjust the dates.",
          { autoClose: 5000, containerId: "Main" }
        );
        setCurrentErrors({
          ...accidentsErrors,
          dateError: "Date range cannot overlap with existing records.",
        });
        setIsAddLoading(false);
        return;
      }
 
      if (accidents.vacBlock) {
        if (!accidents.vacFromDate) {
          accidentsErrors.vacFromDate =
            "From Date is required when Block is ture";
        }
        if (!accidents.vacToDate) {
          accidentsErrors.vacToDate = "To Date is required when Block is ture";
        }
      }
 
      if (Object.keys(accidentsErrors).length === 0) {
        let vacJobResponse = "";
        console.log("onAdd", accidents);
        if (accidents.vacJob) {
          vacJobResponse = await getFieldValuesByTableAndId({
            tableName: "transport.tms_t_job",
            primaryKey: "job_id",
            fieldNames: "job_code",
            ids: accidents.vacJob.toString(),
          });
        }
 
        const vacJobValue =
          vacJobResponse && vacJobResponse.length > 0
            ? vacJobResponse[0].field1
            : "";
        const vacTypeValue = await getTextByValueAndKey(
          "vac_type",
          accidents.vacType
        );
        const vacCategoryValue = await getTextByValueAndKey(
          "vac_category",
          accidents.vacCategory
        );
 
        const vacActiveValue = await getTextByValueAndKey(
          "active",
          accidents.vacActive
        );
 
        const vacDriverResponse = await getFieldValuesByTableAndId({
          tableName: "masterdata.tms_m_employee",
          primaryKey: "emp_id",
          fieldNames: "emp_fullname",
          ids: accidents.vacDriver,
        });
        const vacDriverValue = vacDriverResponse[0].field1;
        let vacHelperValue = "";
        if (accidents.vacHelper !== "" && accidents.vacHelper !== null) {
          const vacHelperResponse = await getFieldValuesByTableAndId({
            tableName: "masterdata.tms_m_employee",
            primaryKey: "emp_id",
            fieldNames: "emp_fullname",
            ids: accidents.vacHelper,
          });
          vacHelperValue = vacHelperResponse[0].field1;
        }
        if (!accidents.vacId || accidents.vacId === null) {
          if (!accidents.id || accidents.id === null) {
            setAccidentsData((prev) => [
              ...prev,
              {
                ...accidents,
                vacTypeValue,
                vacCategoryValue,
                vacDriverValue,
                vacHelperValue,
                vacActiveValue,
                vacJobValue,
                id: accidentCount,
              },
            ]);
            setAccidentCount((prev) => prev + 1);
          } else {
            setAccidentsData((prev) =>
              prev.filter((accident) => accident.id !== accidents.id)
            );
 
            setAccidentsData((prev) => [
              ...prev,
              {
                ...accidents,
                vacCategoryValue,
                vacDriverValue,
                vacHelperValue,
                vacTypeValue,
                vacJobValue,
                vacActiveValue,
              },
            ]);
          }
        } else {
          setAccidentsData((prev) =>
            prev.filter((accident) => accident.vacId !== accidents.vacId)
          );
 
          setAccidentsData((prev) => [
            ...prev,
            {
              ...accidents,
              vacTypeValue,
              vacCategoryValue,
              vacDriverValue,
              vacHelperValue,
              vacActiveValue,
              vacJobValue,
              modified: true,
            },
          ]);
        }
        setButtonClicked(true);
      }
      setCurrentErrors(accidentsErrors);
      // Add error class to the form for styling
      document.querySelector("#vehicle-details-form").classList.add("error");
      setIsAddLoading(false);
    };

    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form
            className="ui form"
            style={{ overflowY: "auto", height: "75vh" }}
          >
            <div className="ui segment">
              <h4 className="ui dividing header">Breakdowns</h4>
              <div className="two fields">
                <Input
                  label="Code"
                  error={currentErrors.vacCode}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="vac_code"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vacCode: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="code"
                  placeholder="Code"
                  value={accidents.vacCode}
                  disabled
                  onChange={(e) =>
                    setAccidents((prev) => ({
                      ...prev,
                      vacCode: e.target.value,
                    }))
                  }
                />
                <Input
                  label="Reference"
                  error={currentErrors.vacReference}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="vac_reference"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vacReference: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="reference"
                  placeholder="Reference"
                  value={accidents.vacReference}
                  onChange={(e) =>
                    setAccidents((prev) => ({
                      ...prev,
                      vacReference: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Category"
                  error={currentErrors.vacCategory}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="vac_category"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vacCategory: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={dropdown.breakdownCategoryOpt}
                  style={{ height: "20px" }}
                  placeholder="Category"
                  value={accidents.vacCategory}
                  onChange={handleCategoryChange}
                />
                <Dropdown
                  required={true}
                  label="Type"
                  error={currentErrors.vacType}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="vac_type"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vacType: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={typeOpt}
                  style={{ height: "20px" }}
                  disabled={!categorySelected || typeOptLoading}
                  placeholder={typeOptLoading ? "Loading ..." : "Type"}
                  value={accidents.vacType}
                  onChange={(e, data) =>
                    setAccidents((prev) => ({ ...prev, vacType: data.value }))
                  }
                />
              </div>
              <div className="two fields">
                <SearchDropdown
                  key={1}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="vac_drive"
                  reset={searchFieldReset}
                  multiGrid={true}
                  multiGridCurrentValue={accidents.vacDriverValue}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setAccidents((prevState) => ({
                      ...prevState,
                      vacDriver: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setAccidents((prevState) => ({
                      ...prevState,
                      vacDriver: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "employee",
                    value: "Driver",
                    // param1: reference ? reference : "",
                    param6: accidents.vacJob === null ? "" : accidents.vacJob,
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_employee",
                    primaryKey: "emp_id",
                    fieldName: "emp_fullname",
                    id: accidents.vacDriver,
                  }}
                  required={true}
                  label="Driver"
                  error={currentErrors.vacDriver}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vacDriver: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />

                <SearchDropdown
                  key={1}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="vac_helper"
                  multiGrid={true}
                  multiGridCurrentValue={accidents.vacHelperValue}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setAccidents((prevState) => ({
                      ...prevState,
                      vacHelper: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setAccidents((prevState) => ({
                      ...prevState,
                      vacHelper: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "employee",
                    value: "Helper",
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_employee",
                    primaryKey: "emp_id",
                    fieldName: "emp_fullname",
                    id: accidents.vacHelper,
                  }}
                  label="Helper"
                  error={currentErrors.vacHelper}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vacHelper: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
              </div>
              <div className="three fields">
                <Input
                  required={true}
                  label="Date"
                  error={currentErrors.vacDate}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="vac_date"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vacDate: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="date"
                  name="date"
                  placeholder="Date"
                  value={formatDateForInput(accidents.vacDate)}
                  min={new Date().toISOString().split("T")[0]}
                  onChange={(e) =>
                    setAccidents((prev) => ({
                      ...prev,
                      vacDate: e.target.value,
                    }))
                  }
                />
                <Input
                  required={accidents.vacBlock ? true : false}
                  label="From Date"
                  error={currentErrors.vacFromDate}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="vac_from_date"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vacFromDate: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="date"
                  name="fromdate"
                  min={new Date().toISOString().split("T")[0]}
                  placeholder="From Date"
                  value={formatDateForInput(accidents.vacFromDate)}
                  onChange={(e) =>
                    setAccidents((prev) => ({
                      ...prev,
                      vacFromDate: e.target.value,
                    }))
                  }
                />
                <Input
                  required={accidents.vacBlock ? true : false}
                  label="To Date"
                  error={currentErrors.vacToDate}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="vac_to_date"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vacToDate: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  type="date"
                  name="todate"
                  min={new Date().toISOString().split("T")[0]}
                  placeholder="To Date"
                  value={formatDateForInput(accidents.vacToDate)}
                  disabled={
                    accidents.vacFromDate === "" ||
                    accidents.vacFromDate === null
                  }
                  onChange={(e) => {
                    if (e.target.value < accidents.vacFromDate) {
                      setCurrentErrors((prev) => ({
                        ...prev,
                        vacToDate: "To date should be greater than from date",
                      }));
                      return;
                    } else {
                      setCurrentErrors((prev) => ({
                        ...prev,
                        vacToDate: "",
                      }));
                    }
                    setAccidents((prev) => ({
                      ...prev,
                      vacToDate: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                <SearchDropdown
                  key={1}
                  label="Job"
                  error={currentErrors.vacJob}
                  module={MODULES.Master}
                  form={FORM}
                  field="vac_job"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vacJob: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  style={{ height: "20px" }}
                  placeholder="Job"
                  multiGrid={true}
                  multiGridCurrentValue={accidents.vacJobValue}
                  editMode={editMode}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setAccidents((prevState) => ({
                      ...prevState,
                      vacJob: null,
                    }));
                  }}
                  onResultSelect={(data) => {
                    setAccidents((prevState) => ({
                      ...prevState,
                      vacJob: data,
                    }));
                  }}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "job",
                    value: "",
                    param1: reference ? reference : "",
                    param2:
                      accidents.vacDriver === null ? "" : accidents.vacDriver,
                  }}
                  fieldInfo={{
                    tableName: "transport.tms_t_job",
                    primaryKey: "job_id",
                    fieldName: "job_code",
                    id: accidents.vacJob,
                  }}
                />

                <Input
                  label="Description"
                  error={currentErrors.vacDescription}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="vac_description"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vacDescription: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="description"
                  placeholder="Description"
                  value={accidents.vacDescription}
                  onChange={(e) =>
                    setAccidents((prev) => ({
                      ...prev,
                      vacDescription: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="two fields">
                <Dropdown
                  required={true}
                  label=" Breakdown Status"
                  error={currentErrors.vacAccidentStatus}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="vac_accident_status"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vacAccidentStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={dropdown.accidentStatusOpt}
                  style={{ height: "20px" }}
                  placeholder="Breakdown Status"
                  value={accidents.vacAccidentStatus}
                  onChange={(e, data) =>
                    setAccidents((prev) => ({
                      ...prev,
                      vacAccidentStatus: data.value,
                    }))
                  }
                />

                <div
                  className={`field ${currentErrors.vacBlock ? "error" : ""}`}
                >
                  <label>Block</label>
                  <Checkbox
                    type="checkbox"
                    name="block"
                    placeholder="Block"
                    checked={accidents.vacBlock}
                    editMode={editMode}
                    module={MODULES.Master}
                    form={FORM}
                    field="vac_block"
                    onChange={() =>
                      setAccidents((prev) => ({
                        ...prev,
                        vacBlock: !prev.vacBlock,
                      }))
                    }
                  />
                  <small style={{ color: "#9f3a38" }}>{`${
                    currentErrors.vacBlock ? currentErrors.vacBlock : ""
                  }`}</small>
                </div>
              </div>
              <div className="two fields">
                <Dropdown
                  label="Status"
                  error={currentErrors.vacStatus}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="vac_status"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vacStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={dropdown.statusOpt}
                  style={{ height: "20px" }}
                  placeholder="Status"
                  value={accidents.vacStatus}
                  onChange={(e, data) =>
                    setAccidents((prev) => ({
                      ...prev,
                      vacStatus: data.value,
                    }))
                  }
                />
                {/* <Dropdown
                  label="Active"
                  error={currentErrors.vacActive}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="vac_active"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vacActive: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={dropdown.activeOpt}
                  style={{ height: "20px" }}
                  placeholder="Active"
                  value={accidents.vacActive}
                  onChange={(e, data) =>
                    setAccidents((prev) => ({
                      ...prev,
                      vacActive: data.value,
                    }))
                  }
                /> */}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  template="reset"
                  onClick={(e) => {
                    setButtonClicked(true);
                  }}
                />
                <Button
                  template="addOrSave"
                  authenticated={true}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={`${FORM}`}
                  create={Object.keys(currentAccident).length === 0}
                  onClick={onAddClick}
                  isLoading={isAddLoading}
                />
              </div>
              <Grid
                heading="Accident List"
                config={[
                  { headerName: "Category", field: "vacCategoryValue" },
                  { headerName: "Type", field: "vacTypeValue" },
                  { headerName: "Reference", field: "vacReference" },
                  { headerName: "Driver", field: "vacDriverValue" },
                  { headerName: "Helper", field: "vacHelperValue" },
                  { headerName: "Date", field: "vacDate" },
                  { headerName: "From Date", field: "vacFromDate" },
                  { headerName: "To Date", field: "vacToDate" },
                  {
                    headerName: "Description",
                    field: "vacDescription",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  { headerName: "Active", field: "vacActiveValue" },
                  {
                    field: "Edit",
                    filter: true,
                    cellRenderer: ButtonRenderer,
                    cellRendererParams: (params) => ({
                      consider: AUTH_TYPES.CREATE,
                      clickHandler: () => {
                        setCurrentAccident(params.data);
                      },
                      label: "Edit",
                      authenticated: true,
                      form: `${FORM}`,
                      module: MODULES.Master,
                      editMode: editMode,
                    }),
                  },
                  {
                    field: "Delete",
                    filter: true,
                    cellRenderer: DeleteButtonRenderer,
                    cellRendererParams: (params) => ({
                      consider: AUTH_TYPES.DELETE,
                      clickHandler: () => {
                        if (params.data.vacId && params.data.vacId !== null) {
                          setDeletedList((prev) => [
                            ...prev,

                            params.data.vacId,
                          ]);
                        }

                        setAccidentsData((prevAccidents) =>
                          prevAccidents.filter(
                            (accident) => accident.id !== params.data.id,
                          ),
                        );
                      },
                      message:
                          "Are you sure you want to delete this Breakdown?",
                      label: "Delete",
                      className: "ui red button",
                      authenticated: true,
                      form: `${FORM}`,
                      module: MODULES.Master,
                      editMode:
                        params.data.vacId !== null &&
                        isNumber(params.data.vacId),
                    }),
                  },
                ]}
                content={accidentsData}
              />
            </div>
          </form>
        )}
      </>
    );
  },
);

export default VehicleAccidents;
